<button
  class="notifications-button"
  [class.red-dot]="notifications()?.length"
  matIconButton
  [matMenuTriggerFor]="menu"
  [disableRipple]="true"
  [matTooltip]="'ALARM.NOTIFICATIONS' | translate">
  <mat-icon>notifications_active</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <p class="notification_title">{{ 'ALARM.NOTIFICATIONS' | translate }}</p>
  @if (notifications()?.length) {
    <div class="cards-notification">
      @for (item of notifications(); track item.uid) {
        <div mat-menu-item class="notifications-menu-item">
          <notification-card>
            <div class="card">
              <mat-icon color="primary">notifications_active</mat-icon>
              <div style="flex: 1">
                <div class="card_content">
                  <h1 class="card_content_title" [matTooltip]="item.label" ubiShowIfTruncated>
                    {{ item.label }}
                  </h1>
                  <div class="card_content_details">
                    @if (item.deviceRegistration; as registration) {
                      <p class="registration-details" [matTooltip]="registration" ubiShowIfTruncated>
                        {{ registration }}
                      </p>
                    }
                    <mat-divider vertical style="height: auto" />
                    @if (item?.date) {
                      <p class="date-details">
                        {{ item.date | dynamicDate: 'short' }}
                      </p>
                    }
                  </div>
                </div>

                <div [style]="{ display: 'flex', gap: '10px', paddingTop: '8px' }">
                  <button
                    matButton="outlined"
                    (click)="navigateToLogDetail(item.uid_alarm)"
                    class="small stretch">
                    {{ 'ALARM.DETAIL' | translate }}
                  </button>
                  <button
                    matButton="filled"
                    color="accent"
                    (click)="acquitLog(item.uid); $event.stopPropagation()"
                    class="small stretch">
                    {{ 'ALARM.ACKNOWLEDGE' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </notification-card>
        </div>
      }
    </div>
    <button
      mat-button
      [style]="{ margin: '0 auto', display: 'block', marginTop: '8px' }"
      (click)="seeAllLogs()">
      <p class="see-all">{{ 'ALARM.SEEALL' | translate }}</p>
    </button>
  } @else {
    <div mat-menu-item>
      <alert genre="muted">{{ 'ALARM.NONOTIFICATION' | translate }}</alert>
    </div>
  }
</mat-menu>
